export default __webpack_public_path__ + "static/media/content-1.a126bfb1.jpg";